import { FC } from 'react'

import { useOrganization } from '../../../app/_providers/OrganizationProvider.client'
import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { isEmbroideryItem } from '../../../lib/utils'
import { CartItem } from '../../../types/figs'
import { CartContainer } from '../../containers/cart'
import { EmbroideryCartItem, RegularCartItem } from '../Cart'

export const MiniCartItem: FC<{
  item: CartItem
  index: number
  /**
   * Temporary addition to support Product Bundle Discounts for the Ribbed Longsleeve Underscrub.
   * @deprecated - do not use outside of temporary Product Bundle Discounts work.
   * @todo remove this after we remove this feature.
   */
  showDiscountAtCheckoutCopy: boolean
}> = ({ item, index, showDiscountAtCheckoutCopy }) => {
  const {
    cart,
    status: cartStatus,
    removeItems,
    updateItemsQuantity,
  } = CartContainer.useContainer()
  const { cart: miniCartCopy } = useTranslation()
  const { hasMandatoryEmbroidery } = useOrganization()

  const key: string = `${item.key}-${index}`

  if (isEmbroideryItem(item)) {
    // Get the item that is associated with this embroidery item
    const [_, associatedEmbroiderableProduct] =
      Object.entries(cart.items).find(
        ([_, cartItem]) =>
          item.key !== cartItem.key && item.properties._guid === cartItem.properties._guid
      ) ?? []

    // If the associated embroiderable products should be removed along with the embroidery
    const shouldRemoveRelatedPortalProduct = hasMandatoryEmbroidery({
      categoryAnalyticsId: associatedEmbroiderableProduct?.productType,
    })

    return (
      <EmbroideryCartItem
        cartItemProperties={item.properties}
        eventCategory='minicart'
        key={key}
        label={miniCartCopy.embroideryItemLabel}
        effectivePrice={item.effectivePrice}
        fullPrice={item.fullPrice}
        removeItem={() =>
          removeItems([item.key], {
            removeAssociatedPortalProduct: shouldRemoveRelatedPortalProduct,
          })
        }
        title={item.title}
      />
    )
  } else {
    return (
      <RegularCartItem
        hasEmbroidery={!!item.properties._guid}
        cartIsUpdating={cartStatus === 'pending'}
        cartItem={item}
        decrementQuantity={() => updateItemsQuantity([item.key], -1)}
        eventCategory='minicart'
        incrementQuantity={() => updateItemsQuantity([item.key], 1)}
        key={key}
        removeItem={() => removeItems([item.key])}
        setQuantity={newQuantity => updateItemsQuantity([item.key], () => newQuantity)}
        uniqueId={key}
        showDiscountAtCheckoutCopy={showDiscountAtCheckoutCopy}
      />
    )
  }
}
